import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiLogOut } from 'react-icons/fi';
import { useAuth } from '../hooks/useAuth';
import styles from './Navbar.module.css';

/**
 * Navbar Component
 * Main navigation bar with logo and user menu
 */
const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const displayName = user?.full_name || user?.username || 'User';
  const organizationName = user?.organization_name
    || (user?.is_superuser ? 'Super User' : 'System User');

  return (
    <nav className={styles.navbar}>
      <div className={styles.container}>
        {/* Logo */}
        {/* link to dashboard */}
        <div className={styles.logo} onClick={() => navigate('/dashboard')} style={{ cursor: 'pointer' }}>
            <img src={require('../assets/img/dha-logo.png')} alt="DHA Logo" style={{ width: '40px', height: '40px', marginRight: '10px' }} />
            <h3>Equipment Gateway</h3>
        </div>

        {/* User Menu */}
        <div className={styles.userMenu}>
          <div className={styles.userIdentity}>
            <span className={styles.username}>{displayName}</span>
            <span className={styles.organization}>{organizationName}</span>
          </div>
          <button 
            className={styles.logoutBtn}
            onClick={handleLogout}
            title="Logout"
          >
            <FiLogOut size={20} />
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
